/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InviteByEmailRequest } from '../../models/invite-by-email-request';
import { ShareInvitationDto } from '../../models/share-invitation-dto';

export interface SharingLinksShareLinkIdInvitePost$Json$Params {
  shareLinkId: string;
      body?: InviteByEmailRequest
}

export function sharingLinksShareLinkIdInvitePost$Json(http: HttpClient, rootUrl: string, params: SharingLinksShareLinkIdInvitePost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ShareInvitationDto>> {
  const rb = new RequestBuilder(rootUrl, sharingLinksShareLinkIdInvitePost$Json.PATH, 'post');
  if (params) {
    rb.path('shareLinkId', params.shareLinkId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShareInvitationDto>;
    })
  );
}

sharingLinksShareLinkIdInvitePost$Json.PATH = '/sharing/links/{shareLinkId}/invite';
